module.exports = __webpack_public_path__ + "img/15.ebaeffc8.png";